import * as React from "react";

const User2 = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.652 20.7703C12.6297 20.7043 12.6264 20.6334 12.6423 20.5655C12.6582 20.4977 12.6929 20.4357 12.7423 20.3865L13.4721 19.6567C13.4493 19.6048 13.4276 19.5526 13.407 19.5001H12.3751C12.2756 19.5001 12.1802 19.4606 12.1099 19.3903C12.0396 19.3199 12.0001 19.2246 12.0001 19.1251V16.875C12.0001 16.7755 12.0396 16.6802 12.1099 16.6098C12.1802 16.5395 12.2756 16.5 12.3751 16.5H13.407C13.4275 16.4475 13.4492 16.3953 13.4721 16.3434L12.7423 15.6135C12.7075 15.5787 12.6798 15.5374 12.661 15.4919C12.6421 15.4464 12.6324 15.3976 12.6324 15.3484C12.6324 15.2991 12.6421 15.2504 12.661 15.2049C12.6798 15.1594 12.7075 15.118 12.7423 15.0832L14.3333 13.4922C14.3681 13.4573 14.4094 13.4297 14.4549 13.4109C14.5004 13.392 14.5492 13.3823 14.5985 13.3823C14.6477 13.3823 14.6965 13.392 14.742 13.4109C14.7875 13.4297 14.8288 13.4573 14.8637 13.4922L15.5935 14.2221C15.6454 14.1992 15.6976 14.1775 15.7501 14.1569V13.125C15.7502 13.0416 15.7781 12.9606 15.8293 12.8949C15.8806 12.8291 15.9523 12.7823 16.0331 12.7618C14.5761 10.8393 12.4572 9.75 10.1251 9.75C7.99122 9.75 6.01984 10.6634 4.57408 12.3218C3.11804 13.9921 2.29759 16.3202 2.25208 18.8979C3.11289 19.332 6.6475 21 10.1251 21C10.9725 20.9971 11.818 20.9203 12.652 20.7703Z"
      fill="currentColor"
    />
    <path
      d="M17.25 18.75C17.6642 18.75 18 18.4142 18 18C18 17.5858 17.6642 17.25 17.25 17.25C16.8358 17.25 16.5 17.5858 16.5 18C16.5 18.4142 16.8358 18.75 17.25 18.75Z"
      fill="currentColor"
    />
    <path
      d="M10.125 9C12.1961 9 13.875 7.32107 13.875 5.25C13.875 3.17893 12.1961 1.5 10.125 1.5C8.05393 1.5 6.375 3.17893 6.375 5.25C6.375 7.32107 8.05393 9 10.125 9Z"
      fill="currentColor"
    />
    <path
      d="M15.251 14.9403L14.5984 14.2875L13.5375 15.3484L14.1901 16.001C14.2466 16.0574 14.2836 16.1304 14.2956 16.2094C14.3077 16.2883 14.2943 16.369 14.2573 16.4398C14.1654 16.6153 14.0893 16.7986 14.0297 16.9875C14.0057 17.0636 13.9581 17.1301 13.8938 17.1774C13.8294 17.2246 13.7517 17.25 13.6719 17.25H12.75V18.75H13.6719C13.7517 18.75 13.8295 18.7754 13.8938 18.8226C13.9582 18.8699 14.0058 18.9364 14.0297 19.0125C14.0894 19.2014 14.1656 19.3846 14.2575 19.56C14.2945 19.6308 14.3079 19.7115 14.2958 19.7905C14.2838 19.8694 14.2468 19.9424 14.1903 19.9989L13.5375 20.6516L14.5984 21.7125L15.251 21.0599C15.3074 21.0034 15.3804 20.9664 15.4594 20.9544C15.5383 20.9423 15.619 20.9557 15.6898 20.9927C15.8653 21.0846 16.0485 21.1608 16.2373 21.2205C16.3134 21.2444 16.3799 21.292 16.4272 21.3564C16.4744 21.4207 16.4998 21.4984 16.4998 21.5782V22.5H17.9998V21.5781C17.9998 21.4983 18.0253 21.4205 18.0725 21.3562C18.1197 21.2919 18.1862 21.2443 18.2623 21.2203C18.4512 21.1606 18.6344 21.0844 18.8098 20.9925C18.8806 20.9555 18.9613 20.9421 19.0402 20.9542C19.1192 20.9662 19.1922 21.0032 19.2487 21.0597L19.9016 21.7125L20.9625 20.6516L20.3099 19.999C20.2534 19.9426 20.2164 19.8696 20.2044 19.7906C20.1923 19.7117 20.2057 19.631 20.2427 19.5602C20.3346 19.3847 20.4107 19.2014 20.4703 19.0125C20.4943 18.9364 20.5419 18.8699 20.6062 18.8226C20.6706 18.7754 20.7483 18.75 20.8281 18.75H21.75V17.25H20.8281C20.7483 17.25 20.6705 17.2246 20.6062 17.1774C20.5418 17.1301 20.4942 17.0636 20.4703 16.9875C20.4106 16.7986 20.3344 16.6154 20.2425 16.44C20.2055 16.3692 20.1921 16.2885 20.2042 16.2095C20.2162 16.1306 20.2532 16.0576 20.3097 16.0011L20.9625 15.3484L19.9016 14.2875L19.249 14.9401C19.1926 14.9966 19.1196 15.0336 19.0406 15.0456C18.9617 15.0577 18.881 15.0443 18.8102 15.0073C18.6347 14.9154 18.4515 14.8392 18.2627 14.7795C18.1866 14.7556 18.1201 14.708 18.0728 14.6436C18.0256 14.5793 18.0002 14.5016 18.0002 14.4218V13.5H16.5V14.4219C16.5 14.5017 16.4746 14.5795 16.4273 14.6438C16.3801 14.7081 16.3136 14.7557 16.2375 14.7797C16.0487 14.8394 15.8654 14.9156 15.69 15.0075C15.6192 15.0445 15.5384 15.058 15.4595 15.0459C15.3805 15.0338 15.3074 14.9968 15.251 14.9403ZM17.25 16.5C17.5467 16.5 17.8367 16.588 18.0834 16.7528C18.33 16.9176 18.5223 17.1519 18.6358 17.426C18.7494 17.7001 18.7791 18.0017 18.7212 18.2926C18.6633 18.5836 18.5204 18.8509 18.3107 19.0607C18.1009 19.2704 17.8336 19.4133 17.5426 19.4712C17.2517 19.5291 16.9501 19.4994 16.676 19.3858C16.4019 19.2723 16.1676 19.08 16.0028 18.8334C15.838 18.5867 15.75 18.2967 15.75 18C15.7504 17.6023 15.9086 17.221 16.1898 16.9398C16.471 16.6586 16.8523 16.5004 17.25 16.5Z"
      fill="currentColor"
    />
    <defs>
      <linearGradient
        id="paint0_linear_402:5374"
        x1="2.25208"
        y1="9.75"
        x2="2.25208"
        y2="21"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_402:5374"
        x1="16.5"
        y1="17.25"
        x2="16.5"
        y2="18.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_402:5374"
        x1="6.375"
        y1="1.5"
        x2="6.375"
        y2="9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_402:5374"
        x1="12.75"
        y1="13.5"
        x2="12.75"
        y2="22.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
    </defs>
  </svg>
);

export default User2;
